export const constants = {
  CATEGORIES: [
    { name: '', link: '' },
    { name: 'Butai / bendrabučiai', link: 'butai' },
    { name: 'Namai / kotedžai', link: 'namai' },
    { name: 'Sodai / sodybos', link: 'sodai' },
    { name: 'Žemės sklypai', link: 'sklypai' },
    { name: 'Komercinės', link: 'komercines' },
    { name: 'Patalpos garažai', link: 'garazai' },
  ],
  urls: {
    HOST_FRONT: 'https://tikes-grupe.netlify.app', //'http://83-229-85-195.cloud-xip.io:3001', // http://localhost:3000, //
    DASHBOARD: '/konsole',
    MAIN: '/pagrindinis',
    OBJECTS: '/objektai',
    OBJECT_CATEGORY: '/objektai/:objectCategory',
    OBJECT_ITEM: '/objektai/:objectCategory/:objectId',
    SALES: '/parduoti',
    ABOUT: '/apie_mus',
    CAREER: '/karjera',
    CAREER_ITEM: '/karjera/:id',
    VIDEO: '/video',
    CONTACTS: '/kontaktai',
    CONFIRM_MAIL: '/mail/:token',
    CONSOLE_OBJECTS: '/console/objectai',
    CONSOLE_OBJECTS_CREATE: '/console/objectai/create',
    CONSOLE_OBJECTS_UPDATE: '/console/objectai/:objectId',
    CONSOLE_PROFILE: '/console/profilis',
    CONSOLE_USERS: '/console/brokere',
    CONSOLE_USER: '/console/brokere/:id',
    CONSOLE_PARTNERS: '/console/partneriai',
    CONSOLE_CAREER: '/console/karjera',
    CONSOLE_CAREER_NEW: '/console/karjera/nauja',
    CONSOLE_CAREER_ITEM: '/console/karjera/:id',
    CONSOLE_COUNTRIES: '/console/salis',
  },
  dateOptions: {
    DAY_ONLY: {
      day: '2-digit',
    },
    FULL_DATE: {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    },
    FULL_DATE_TIME: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    },
  },
  preloader: {
    PRELOADER_COLORS: ['#3347F9', '#BBC2FF'],
  },
  BASE_URL: 'https://tikes.herokuapp.com', //'http://83-229-85-195.cloud-xip.io:3001', //'http://localhost:3002', //
  endpoints: {
    CREATE: '/user/create',
    LOGIN: '/user/login',
    LOGOUT: '/user/logout',
    VERIFY: '/user/verify',
    RESET: '/user/verify/reset',
    REFRESH: '/user/refresh',
    UPDATE_USER: '/user/update_user',
    UPDATE_AVATAR: '/user/update_avatar',
    GET_BROKERS: '/user/users',
    GET_USER: '/user',
    DELETE_USER: '/user',
    ADD_PARTNER: '/partner',
    GET_PARTNERS: '/partner/all',
    UPDATE_PARTNER_STATE: '/partner/update_state',
    UPDATE_PARTNER_IMAGE: '/partner/update_image',
    DELETE_PARTNER: '/partner',
    ADD_OBJECT: '/object',
    ADD_ADVERT: '/object/mail',
    UPDATE_OBJECT: '/object',
    DELETE_OBJECT: '/object',
    GET_OBJECTS: '/object/all',
    GET_BROKERS_OBJECTS: '/object/all',
    GET_CAREER: '/career/all',
    ADD_CAREER: '/career',
    UPDATE_CAREER: '/career',
    DELETE_CAREER: '/career',
    ADVERT_CAREER: '/career/mail',
    GET_COUNTRY: '/geo/country/all',
    GET_CITY: '/geo/city/all',
    GET_REGION: '/geo/region/all',
    ADD_COUNTRY: '/geo/country',
    ADD_CITY: '/geo/city',
    ADD_REGION: '/geo/region',
    UPDATE_COUNTRY: '/geo/country',
    UPDATE_CITY: '/geo/city',
    UPDATE_REGION: '/geo/region',
    DELETE_COUNTRY: '/geo/country',
    DELETE_CITY: '/geo/city',
    DELETE_REGION: '/geo/region',
  },
  CAREER_TYPES: ['', 'Pilnas laikas', 'Ne pilnas laikas'],
  EXPERIENCE_OPTIONS: ['', '0.5 - 1', '1', '1 - 2', '1 - 3', '2', '3', '3+'],
  ROOM_TYPES: {
    LIVING_ROOM: { index: 1, name: 'guļamistaba' },
    DINNING_ROOM: { index: 2, name: 'ēdamistaba' },
    KITCHEN: { index: 3, name: 'virtuve' },
    WC: { index: 4, name: 'tualete' },
    BATHROOM: { index: 5, name: 'vannas istaba' },
  },
  MATERIAL_TYPES: {
    //GARAŽAI
    BRICK: { index: 1, name: 'Mūrinis' },
    IRON: { index: 2, name: 'Geležinis' },
    UNDERGROUND: { index: 3, name: 'Požeminis' },
    HIGH: { index: 4, name: 'Daugiaaukštis' },
    ///PATALPOS
    UNDERGROUND_SITE: { index: 5, name: 'Požeminėje aikštelėje' },
    ONGROUND_SITE: { index: 6, name: 'Antžeminėje aikštelėje' },
    HIGH_SITE: { index: 7, name: 'Daugiaaukštėje aikštelėje' },
    ///BUTAI, NAMAI
    FRAME: { index: 8, name: 'Karkasinis' },
    BLOCK: { index: 9, name: 'Blokinis' },
    LOG: { index: 10, name: 'Rąstinis' },
    MONOLITE: { index: 11, name: 'Monolitinis' },
    WOODEN: { index: 12, name: 'Medinis' },
    //
    KITA: { index: 13, name: 'Kita' },
  },
  ARRANGEMENT_TYPES: {
    //ĮRENGIMAS
    FULL: { index: 1, name: 'Įrengtas' },
    PART: { index: 1, name: 'Dalinė apdaila' },
    NO_ARRANGEMENT: { index: 1, name: 'Neįrengtas' },
    NOT_FINISHED: { index: 1, name: 'Nebaigtas statyti' },
    FOUNDATION: { index: 1, name: 'Pamatai' },
    NO: { index: 1, name: 'Kita' },
  },
  HEATING_TYPES: {
    //ŠILDYMAS
    CENTRAL: { index: 1, name: 'Centrinis' },
    CENTRAL_TERMOSTAT: { index: 2, name: 'Centrinis kolektorinis' },
    GAS: { index: 3, name: 'Dujinis' },
    ELECTRIC: { index: 4, name: 'Elektra' },
    AEROTHERMAL: { index: 5, name: 'Aeroterminis' },
    GEOTHERMAL: { index: 6, name: 'Geoterminis' },
    LIQUID: { index: 7, name: 'Skystu kuru' },
    SOLID_FUEL: { index: 8, name: 'Kietu kuru' },
    SUN_BATTARIES: { index: 9, name: 'Saulės baterijo' },
    OTHER: { index: 10, name: 'Kita' },
  },
  //Ypatybės
  FEATURES: [
    'Atskiras įėjimas',
    'Butas per kelis aukštus',
    'Nauja elektros instaliacija',
    'Kabelinė televizija',
    'Butas palėpėje',
    'Nauja kanalizacija',
    'Aukštos lubos',
    'Tualetas ir vonia atskirai',
    'Uždaras kiemas',
    'Virtuvė sujungta su kambariu',
    'Internetas',
    'Buto dalis',
  ],
  //Papildomos patalpos
  PREMICES: [
    'Sandėliukas',
    'Rūsys',
    'Yra palėpė',
    'Balkonas',
    'Pirtis',
    'Drabužinė',
    'Terasa',
    'Vieta automobiliui',
  ],
  //Papildoma įranga
  EQUIPMENT: [
    'Kondicionierius',
    'Šaldytuvas',
    'Viryklė',
    'Indaplovė',
    'Rekuperacinė sistema',
    'Skalbimo mašina',
    'Vonia',
    'Šildomos grindys',
    'Židinys',
    'Dušo kabina',
    'Su baldais',
    'Virtuvės komplektas',
    'Plastikiniai vamzdžiai',
  ],
  //Apsauga
  SECURITY: [
    'Šarvuotos durys',
    'Vaizdo kameros',
    'Signalizacija',
    'Budintis sargas',
    'Kodinė laiptinės spyna',
  ],
  DEFAULT_OBJECT_DATA: {
    category: 0,
    type: 1,
    country: '',
    city: '',
    region: '',
    address: '',
    title: '',
    broker: '',
    images: [],
    rooms: [],
    features: [],
    price: '',
    square: '',
    heating: 0,
    client: {
      email: '',
      phone: '',
      name: '',
    },
  },
};
